import { DatePipe, NgIf } from '@angular/common';
import { Component, Input } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatToolbarModule } from '@angular/material/toolbar';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';
import * as Global from '../../../../global';
import { HelpersService } from '../../../../services/helpers.service';
import { NavService } from '../../../../services/nav.service';
import {
  FormBuilder,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { ToastService } from '@app/services/toast.service';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { SupportService } from '../support.service';

@Component({
  selector: 'request-a-call',
  standalone: true,
  imports: [
    MatToolbarModule,
    MatFormFieldModule,
    MatInputModule,
    MatIconModule,
    FormsModule,
    ReactiveFormsModule,
    MatButtonModule,
    MatIconModule,
    NgxSkeletonLoaderModule,
    DatePipe,
    NgIf,
    MatDatepickerModule
  ],
  templateUrl: './request-a-call.component.html',
  styleUrl: './request-a-call.component.scss'
})
export class RequestACallComponent {
  @Input() data: any = null;
  Global = Global;
  isLoading: boolean = false;
  notifications: any = [];
  formGroup!: FormGroup;
  constructor(
    private fb: FormBuilder,
    public toastr: ToastService,
    public navService: NavService,
    private supportService: SupportService,
    private helpers: HelpersService
  ) {}
  ngOnChanges() {
    this.formGroup = this.fb.group({
      requestText: [null, Validators.compose([Validators.required])],
      contactNo: [null, Validators.compose([Validators.required,Validators.pattern(/^\d{10}$/)])],
      documentData: [null, Validators.compose([])],
      documentName: [null, Validators.compose([])],
      requestCallDate: [null, Validators.compose([Validators.required])],
      requestCallTime: [null, Validators.compose([Validators.required])],
    });
  }
  clear() {
    this.formGroup.patchValue({
      documentData: null,
      documentName: null,
    });
  }
  onSubmit(event: any) {
    this.formGroup.markAllAsTouched();
    if (this.formGroup.valid) {
      event.target.classList.add('btn-loading');
      event.target.disabled = true;
      let formData: any = this.formGroup.value
      this.supportService.requestACall(formData).subscribe({
        next: (res) => {
          this.toastr.success(
            `Request Sent successfully`
          );
          this.navService.openSideNav({ toogle: true })
        },
        error: (err) => {
          event.target.classList.remove('btn-loading');
          event.target.disabled = false;
        },
        complete: () => {
          event.target.classList.remove('btn-loading');
          event.target.disabled = false;
        },
      });
    }
  }
}
